'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-legend/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var formatNumber = _sdk2.default.formatNumber;
var ref = _sdk2.default.utils;
var constants = ref.constants;
var plotUtils = ref.plotUtils;
var scales = ref.scales;
var ref$1 = _sdk2.default.shapes;
var Text = ref$1.Text;
var NumberText = ref$1.NumberText;
var Layer = ref$1.Layer;
var Point = ref$1.Point;
var ShapeGroup = ref$1.ShapeGroup;
var MAX_TEXT_WIDTH = 40;
var legendPadding = constants.LEGEND.PADDING;
var MAX_RADIUS = constants.MARK.POINT.MAX_RADIUS; // show a radial legend if the maxRadius is greater than 20

function _isRadialLegend(maxRadius) {
  return maxRadius > 20;
} // width of the largest circle in the radial legend


function _getRadialWidth(maxRadius) {
  var width = Math.min(maxRadius, MAX_RADIUS);
  return width * 2 + legendPadding;
}

function _dotLegendSwatchSize(swatchSize, swatchPadding) {
  return swatchSize * 2 + swatchPadding;
} // dot legend width is the size of the swatch + text size


function _dotLegendWidth(swatchSize, swatchPadding) {
  return _dotLegendSwatchSize(swatchSize, swatchPadding) + MAX_TEXT_WIDTH;
}

function _getScale(maxValue, maxRadius) {
  return scales.sqrt().domain([0, maxValue]).range([0, maxRadius]);
}

function plotDot(plotLayer, config) {
  var theme = config.theme;
  var format = config.format;
  var maxValue = config.maxValue;
  var maxRadius = config.maxRadius;
  var swatchSize = config.swatchSize;
  var transforms = config.transforms;
  var padding = config.swatchPadding;

  var radiusScale = _getScale(maxValue, maxRadius);

  var horizontalLayout = transforms.rotate;
  var plot = plotLayer.getCell();
  var fitSize = plot.get("h");
  var width = plot.get("w");
  maxRadius = Math.min(Math.max(maxRadius, constants.MARK.POINT.MIN_RADIUS), swatchSize);
  var rowHeight = swatchSize * 2 + padding;
  var domain = [maxRadius, 2 * maxRadius / 3, maxRadius / 2].filter(function (value) {
    return value > constants.MARK.POINT.MIN_RADIUS;
  });
  var rightPad = padding / 2;
  var vPad = (rowHeight - new Text().getH()) / 2;
  var leftPad = horizontalLayout ? swatchSize + 2 * padding : swatchSize + swatchSize / 2 + 2 * padding;
  var maxTextWidth = 0;
  var texts = domain.map(function (value, index) {
    var txt = new NumberText({
      key: "key_label" + index,
      x: horizontalLayout ? width / 2 + padding / 2 : 0,
      y: 0,
      halign: horizontalLayout ? "right" : "left",
      valign: "middle",
      vertical: horizontalLayout,
      padding: {
        left: horizontalLayout ? leftPad : leftPad - padding / 2,
        right: horizontalLayout ? rightPad : rightPad - padding / 2,
        top: vPad,
        bottom: vPad
      },
      stroke: theme.getLegendTextColor(),
      format: format,
      compact: true,
      number: radiusScale.invert(value)
    });
    maxTextWidth = Math.max(maxTextWidth, txt.getTextW());
    return txt;
  });
  var entrySize = horizontalLayout ? maxTextWidth + swatchSize * 2 + padding : rowHeight;
  var maxRows = Math.floor(fitSize / entrySize);

  if (maxRows < 1 || domain.length < 1) {
    plot.remove(plotLayer);
    return;
  }

  domain.forEach(function (value, index) {
    if (value < constants.MARK.POINT.MIN_RADIUS || index >= maxRows) {
      return;
    }

    var shapeGroup = new ShapeGroup({
      layer: plotLayer,
      key: "key" + index,
      canHover: false
    });
    new Point({
      shapeGroup: shapeGroup,
      key: "key_dot" + index,
      x: horizontalLayout ? width / 2 + rightPad : rightPad + swatchSize,
      y: horizontalLayout ? rightPad + swatchSize : 0,
      r: value,
      fill: theme.getRadialLegendBGColor(),
      stroke: theme.getRadialLegendBorderColor(),
      skipInFind: true
    });
    texts[index].prependTo(shapeGroup);

    if (horizontalLayout) {
      shapeGroup.offsetX(-padding / 2);
    } else {
      shapeGroup.offsetY(rowHeight / 2);
    }
  }); // layout legend items

  plotLayer.applyLayout({
    type: "vbox"
  });
}

function plotRadial(plotLayer, config) {
  var theme = config.theme;
  var maxValue = config.maxValue;
  var maxRadius = config.maxRadius;
  var format = config.format;
  var plot = plotLayer.getCell();
  var width = plot.get("w");
  var height = plot.get("h");
  var padding = config.swatchPadding;
  var horizontalLayout = config.transforms.rotate; // construct sqrt scale for radial

  var radiusScale = _getScale(maxValue, maxRadius);

  if (maxValue === 0) {
    return;
  }

  var fitSize = Math.min(width - padding, height - padding, 2 * maxRadius, 2 * MAX_RADIUS);
  var maxValToFit = radiusScale.invert(fitSize / 2);
  maxValue = Math.min(maxValToFit, maxValue);
  var radiusVals = [maxValue, 4 * maxValue / 9, maxValue / 9];
  var startingPoint = horizontalLayout ? width / 2 + fitSize / 2 : fitSize + padding / 2;
  var centerX = fitSize / 2 + padding / 2;
  var circlesDisplayed = 0;
  var maxRadiusDisplayed = 0;
  var displayedValues = [];
  radiusVals.forEach(function (rs) {
    var radius = radiusScale.scale(rs);

    if (radius < constants.RADIAL_LEGEND.MIN_RADIUS) {
      return;
    }

    if (circlesDisplayed > 0) {
      var lastDisplayedRadius = radiusScale.scale(displayedValues[circlesDisplayed - 1]);

      if (2 * radius > 2 * lastDisplayedRadius - constants.RADIAL_LEGEND.TEXT.SIZE - 3) {
        return;
      }
    }

    circlesDisplayed++;
    displayedValues.push(rs);

    if (maxRadiusDisplayed < radius) {
      maxRadiusDisplayed = radius;
    }
  });

  if (!circlesDisplayed) {
    plot.remove(plotLayer);
    return;
  }

  displayedValues.forEach(function (rs, i) {
    var radius = radiusScale.scale(rs);
    var centerY = startingPoint - radius;
    new Point({
      layer: plotLayer,
      key: "key_dot" + i,
      x: horizontalLayout ? width - centerY : centerX,
      y: horizontalLayout ? centerX : centerY,
      r: radius,
      fill: theme.getRadialLegendBGColor(),
      stroke: theme.getRadialLegendBorderColor(),
      lineWidth: constants.RADIAL_LEGEND.BORDER.WIDTH
    });
    new NumberText({
      layer: plotLayer,
      x: horizontalLayout ? width - centerY + radius - constants.RADIAL_LEGEND.TEXT.PADDING : centerX,
      y: horizontalLayout ? centerX : centerY - radius + constants.RADIAL_LEGEND.TEXT.PADDING - 3,
      vertical: horizontalLayout,
      halign: "center",
      valign: "middle",
      format: format,
      compact: true,
      number: rs,
      stroke: theme.getRadialLegendTextColor(),
      key: "key_label" + i,
      size: constants.RADIAL_LEGEND.TEXT.SIZE
    });
  });
}

var RadialLegend = function (AbstractLegend) {
  function RadialLegend() {
    AbstractLegend.apply(this, arguments);
  }

  if (AbstractLegend) RadialLegend.__proto__ = AbstractLegend;
  RadialLegend.prototype = (0, _create2.default)(AbstractLegend && AbstractLegend.prototype);
  RadialLegend.prototype.constructor = RadialLegend;

  RadialLegend.prototype.getDefaultConfig = function getDefaultConfig() {
    return _core2.default.extend(AbstractLegend.prototype.getDefaultConfig.call(this), {
      maxValue: 0,
      maxRadius: constants.MARK.POINT.MAX_RADIUS,
      selectMode: constants.SELECTMODE.NONE
    });
  };

  RadialLegend.prototype.sanitizeConfig = function sanitizeConfig() {
    AbstractLegend.prototype.sanitizeConfig.call(this);
    var config = this.config;
    config.maxRadius = Math.max(0, config.maxRadius);
  }; // The max size a radial legend would require in vertical layout
  // radial legend width is the width of the largest circle
  // dot legend width is the size of the swatch + text size
  // dot legend height is the Max of swatch size and text font size


  RadialLegend.prototype.getVerticalSize = function getVerticalSize() {
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var maxRadius = config.maxRadius;
    var swatchSize = config.swatchSize;
    var swatchPadding = config.swatchPadding;
    var headerSize = this.getHeaderSize(true);

    var radialWidth = _getRadialWidth(maxRadius);

    var dotLegendWidth = _dotLegendWidth(swatchSize, swatchPadding);

    var width = Math.max(headerSize[0], dotLegendWidth, radialWidth);
    var height = headerSize[1] + Math.max(_dotLegendSwatchSize(swatchSize, swatchPadding) * 3, radialWidth);
    return [width, height];
  }; // The max size a radial legend would require in horizontal layout
  // radial legend width and height is the width of the largest circle
  // dot legend width is the size of the swatch + text size of compact number
  // dot legend height is the Max of swatch size and text font size


  RadialLegend.prototype.getHorizontalSize = function getHorizontalSize() {
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var maxRadius = config.maxRadius;
    var swatchSize = config.swatchSize;
    var swatchPadding = config.swatchPadding;

    var radialWidth = _getRadialWidth(maxRadius);

    var headerSize = this.getHeaderSize(false);

    var dotLegendWidth = _dotLegendWidth(swatchSize, swatchPadding);

    var width = headerSize[0] + Math.max(dotLegendWidth * 3, radialWidth);
    var height = Math.max(_dotLegendSwatchSize(swatchSize, swatchPadding), headerSize[1], radialWidth);
    return [width, height];
  };

  RadialLegend.prototype.plotFunction = function plotFunction(plot) {
    var config = this.config;
    var maxRadius = config.maxRadius;
    var transforms = config.transforms;
    var fitHeight = config.fitHeight;
    var fitWidth = config.fitWidth;
    var plotLayer = new Layer({
      cell: plot,
      key: "plot",
      canHover: false,
      canSelect: false
    });
    var scene = plot.getScene();
    var horizontalLayout = transforms.rotate;
    var size = [plot.get("w"), plot.get("h")];
    size[0] > 50 && size[1] > 50 && _isRadialLegend(maxRadius) ? plotRadial(plotLayer, config) : plotDot(plotLayer, config); // compact legend grid
    // fit or fix size on non-scrolling direction

    var fitForNonScroll = horizontalLayout ? fitHeight : fitWidth; // fit or fix size on scrolling direction

    var fitForScroll = horizontalLayout ? fitWidth : fitHeight; // - on scrolling dimension

    if (fitForScroll) {
      scene.adjustRowToFit(plot.get("row"));
    } // - on non-scrolling dimension


    if (fitForNonScroll) {
      scene.adjustColumnToFit(plot.get("column"));
    }
  };

  return RadialLegend;
}(_index2.default);

exports.default = RadialLegend;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;